import { ADD_FILTER, CLEAR_FILTER, RECALCULATION_FILTER, REMOVE_TAG, SET_INITIAL_SELECTORS_VALUES } from '../constans';

const initState = {
  selectorsFieldData: [
    {
      type: 'hub',
      selectLabel: 'Hub',
      title: 'Select',
      isDoubleColumns: true,
      isMultiSelect: true,
      isClear: true,
      isTags: true,
      isSearch: true,
      dependenceSelect: 'project',
      selectedItems: [],
      commonOptions: [],
    },
    {
      type: 'project',
      selectLabel: 'Projects',
      title: 'Select',
      isDoubleColumns: true,
      isMultiSelect: true,
      isClear: true,
      isTags: true,
      isSearch: true,
      dependenceSelect: 'model',
      selectedItems: [],
      commonOptions: [],
    },
    {
      type: 'model',
      selectLabel: 'Model',
      title: 'Select',
      isDoubleColumns: true,
      isMultiSelect: true,
      isClear: true,
      isTags: true,
      isSearch: true,
      dependenceSelect: 'lod',
      selectedItems: [],
      commonOptions: [],
    },
    {
      type: 'lod',
      selectLabel: 'LOD',
      title: 'Select',
      isDoubleColumns: false,
      isMultiSelect: true,
      isClear: true,
      isTags: true,
      isSearch: false,
      selectedItems: [],
      commonOptions: [],
    },
  ],
  selectsOptionsDependsSchema: {},
};

const getDataFromSchema = (schema, key) => {
  if (key === 'lod') {
    return [100, 200, 300, 400, 500];
  }
  return [...new Set(Object.values(schema[key]).flat())];
};

const statisticsFiltersReducer = (state = initState, { type, payload }) => {
  const currentSelectField = {
    ...state.selectorsFieldData.find((field) => field.type === payload?.filterType),
  };

  if (!currentSelectField) {
    return state;
  }

  switch (type) {
    case CLEAR_FILTER: {
      currentSelectField.selectedItems = [];
      let clearElements;
      return {
        ...state,
        selectorsFieldData: state.selectorsFieldData.map((field) => {
          if (field.type === currentSelectField.type) {
            clearElements = true;
            return currentSelectField;
          }
          if (clearElements) {
            field.selectedItems = [];
            field.commonOptions = getDataFromSchema(state.selectsOptionsDependsSchema, field.type);
            return field;
          }
          return field;
        }),
      };
    }

    case SET_INITIAL_SELECTORS_VALUES: {
      const { selectsOptionsDependsSchema } = payload;
      return {
        ...state,
        selectorsFieldData: state.selectorsFieldData.map((field) => {
          field.commonOptions = getDataFromSchema(selectsOptionsDependsSchema, field.type);
          return field;
        }),
        selectsOptionsDependsSchema: { ...payload.selectsOptionsDependsSchema },
      };
    }

    case RECALCULATION_FILTER: {
      return {
        ...state,
        selectorsFieldData: state.selectorsFieldData.map((field) => {
          if (field.type === currentSelectField.dependenceSelect) {
            if (currentSelectField.dependenceSelect === 'lod') {
              field.commonOptions = [100, 200, 300, 400, 500];
              return field;
            }

            const currentSelectOptionsDependsSchema =
              state.selectsOptionsDependsSchema[currentSelectField.dependenceSelect];

            if (currentSelectField.selectedItems?.length > 0) {
              field.commonOptions = [
                ...new Set(
                  currentSelectField.selectedItems
                    .map((currentSchemaKey) => {
                      return currentSelectOptionsDependsSchema[currentSchemaKey];
                    })
                    .flat()
                ),
              ];

              return field;
            }

            field.commonOptions = [...new Set(Object.values(currentSelectOptionsDependsSchema).flat())];
            return field;
          }
          return field;
        }),
      };
    }

    case ADD_FILTER: {
      if (!payload.isMultiSelect) {
        currentSelectField.selectedItems = [payload.value];
      } else if (!currentSelectField.selectedItems.includes(payload.value)) {
        currentSelectField.selectedItems = [...currentSelectField.selectedItems, payload.value];
      } else if (currentSelectField.selectedItems.includes(payload.value)) {
        currentSelectField.selectedItems = currentSelectField.selectedItems.filter((item) => item !== payload.value);
      }

      return {
        ...state,
        selectorsFieldData: state.selectorsFieldData.map((field) => {
          if (field.type === currentSelectField.type) {
            return currentSelectField;
          }
          return field;
        }),
      };
    }

    case REMOVE_TAG: {
      currentSelectField.selectedItems = currentSelectField.selectedItems.filter((item) => item !== payload.value);
      let clearElements;
      return {
        ...state,
        selectorsFieldData: state.selectorsFieldData.map((field) => {
          if (field.type === currentSelectField.type) {
            clearElements = true;
            return currentSelectField;
          }
          if (clearElements) {
            field.selectedItems = [];
            field.commonOptions = getDataFromSchema(state.selectsOptionsDependsSchema, field.type);
            return field;
          }
          return field;
        }),
      };
    }

    default:
      return state;
  }
};
export default statisticsFiltersReducer;
